import { useAuth } from "@/hooks/useAuth/useAuth";
import { Media } from "@/models/Media.model";
import {
  ArrowLeftOutlined,
  DeleteOutlined,
  FileAddOutlined,
  FilePdfOutlined,
  HomeOutlined,
  TeamOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { SelectorQuery } from "@base/components/form/SelectorQuery/SelectorQuery";
import useHttp from "@base/hooks/useHttp/useHttp";
import { usePagina } from "@base/hooks/usePagina/usePagina";
import { quitarSignos, ValidarRfc, ValidarTelefono } from "@base/utils";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Empty,
  Form,
  Image,
  Input,
  InputNumber,
  Layout,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Spin,
  Tooltip,
  Typography,
  Upload,
} from "antd";
import { Header } from "antd/es/layout/layout";
import {
  useCallback,
  useEffect,
  useMemo,
  useState,
  type PropsWithChildren,
} from "react";
import { PatternFormat } from "react-number-format";
import parse from "html-react-parser";
import { useQuery } from "@tanstack/react-query";
import logo from "@/assets/logo_white.png";
import VITE_ENV from "@/config/constants/vite-env";
import dayjs from "dayjs";
import { Grupo } from "@/models/Grupo.model";

export const Route = createFileRoute("/(public)/registro")({
  component: RouteComponent,
});

function EtiquetaCampo({
  children,
  style,
  className,
}: PropsWithChildren<{ style?: React.CSSProperties; className?: string }>) {
  return (
    <Typography.Text
      className={`!text-base md:!text-xl ${className || ""}`}
      style={style}
      strong
    >
      {children}
    </Typography.Text>
  );
}

function RouteComponent() {
  const [form] = Form.useForm();

  const { usuario } = useAuth();

  const http = useHttp();

  const { queryParams } = usePagina();

  const navigate = useNavigate();
  const [guardando, setGuardando] = useState<boolean>(false);
  const [guardado, setGuardado] = useState<any | undefined>(undefined);
  const [mensaje, setMensaje] = useState<string>("");
  const [arregloMedia, setArregloMedia] = useState([]);
  const [listaArchivos, setListaArchivos] = useState<Media[]>([]);

  const [municipios, setMunicipios] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [appendGiros, setAppendGiros] = useState([]);
  const [appendRegimen, setAppendRegimen] = useState<any[]>([]);
  const [razonSocialPDF, setRazonSocialPDF] = useState("");
  const [tipoPersona, setTipoPersona] = useState<string | null>(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tipoModal, setTipoModal] = useState("");
  const [infoRequerida, setInfoRequerida] = useState<any | null>(null);
  const [modalVideo, setModalVideo] = useState(false);
  const [sociedadSat, setSociedadSat] = useState(null);

  const [estado, setEstado] = useState<Record<string, any> | null>(null);
  const [model, setModel] = useState<any | null>();
  const [tieneConstancia, setTieneConstancia] = useState<boolean>(false);
  const [bloqueaRegimen, setBloqueaRegimen] = useState<boolean>(true);

  const requestParams = useMemo(
    () => ({
      expad: "giro",
      id: queryParams?.p,
    }),
    [queryParams?.p],
  );

  const [idGrupo, setIdGrupo] = useState<string | null>(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("grupo");
  });

  const handleSeleccionarGrupo = useCallback((id: string) => {
    const params = new URLSearchParams(window.location.search);
    params.set("grupo", id);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${params.toString()}`,
    );
    setIdGrupo(id);
  }, []);

  const { data } = useQuery({
    queryKey: ["proveedores/empresa.json", requestParams, http],
    queryFn: () =>
      http.get({
        endpoint: "proveedores/empresa.json",
        params: requestParams,
      }),
    enabled: Boolean(queryParams?.p),
  });

  const { data: grupoQ } = useQuery({
    queryKey: [Grupo.ENDPOINTS.PUBLICO, idGrupo, http],
    queryFn: () =>
      http.get({
        endpoint: Grupo.ENDPOINTS.PUBLICO,
        params: { id: idGrupo },
      }),
    enabled: Boolean(idGrupo),
  });

  const grupo = grupoQ?.resultado ? grupoQ?.resultado[0] : null;

  const { data: gruposListaQ, isLoading: cargandoGrupos } = useQuery({
    queryKey: [Grupo.ENDPOINTS.PUBLICO, "lista", http],
    queryFn: () =>
      http.get({
        endpoint: Grupo.ENDPOINTS.PUBLICO,
      }),
    enabled: !idGrupo,
  });

  const gruposDisponibles = gruposListaQ?.resultado ?? [];

  const styles = {
    headerText: {
      fontSize: "16px",
      fontFamily: "system-ui",
      fontWeight: "bold",
      padding: "10px 0",
      color: "#454545",
    },
    textoGuardado: {
      fontSize: "14px",
      borderBottom: "1px solid #000000",
      padding: "12px",
      color: "#454545",
    },
    colsText: {
      alignSelf: "center",
    },
    cardHeader: {
      padding: "2em 8em",
      backgroundColor: "#242424",
      marginTop: "2vh",
      marginBottom: "3vh",
      borderRadius: "5px",
      color: "white ",
    },

    content: {
      background: "#fff",
      padding: 10,
      borderRadius: 5,
      display: "flex",
      alignItems: "baseline",
    },
    header: {
      padding: 0,
      background: "#fff",
      height: "auto",
      lineHeight: "normal",
    },
    buttons: {
      background: "#fff",
      padding: 10,
      borderRadius: 6,
    },
  };

  const debounceRegimen = useCallback(
    (v: any) => {
      const _clave = v.clave;
      if (_clave !== "605") {
        setBloqueaRegimen(false);
        return;
      }
      setBloqueaRegimen(true);
      notification.warning({
        message: "Atención",
        description: "Es necesario seleccionar otro régimen",
      });
      form.resetFields(["idRegimenFiscal"]);
      return;
    },
    [form],
  );

  const processPDF = useCallback(
    async (url: string) => {
      let informacion;
      try {
        await http.get({
          endpoint: `proveedor/registro-proveedor/descargar-pdf.json`,
          params: { url: url },
          onSuccess: (res) => {
            informacion = res?.resultado![0];

            const sat = informacion?.sat;
            const pdf = informacion?.resultadoPdf ?? {};

            const esMoral = Boolean(sat?.regimenCapital);
            const tipoPersonaDetectado = esMoral ? "Moral" : "Física";

            const _nombre = pdf["Nombre (s)"] || sat?.nombre || "";
            const _primerApellido =
              pdf["Primer Apellido"] || sat?.primerApellido || "";
            const _segundoApellido =
              pdf["Segundo Apellido"] || sat?.segundoApellido || "";

            const nombrePersonaFisicaPdf = [
              _nombre,
              _primerApellido,
              _segundoApellido,
            ]
              .filter(Boolean)
              .join(" ");

            const razonSocial =
              sat?.razonSocial ||
              pdf["Nombre, denominación o razón social"] ||
              nombrePersonaFisicaPdf;

            const nombre =
              tipoPersonaDetectado === "Física"
                ? razonSocial
                : sat?.nombre || nombrePersonaFisicaPdf;

            const estado =
              sat?.estado || pdf["Nombre de la Entidad Federativa"];
            const ciudad = sat?.ciudad || pdf["Nombre de la Localidad"];
            const calle = sat?.calle || pdf["Nombre de Vialidad"];
            const numeroExterior =
              sat?.numeroExterior || pdf["Número Exterior"];
            const numeroInterior =
              sat?.numeroInterior || pdf["Número Interior"];
            const colonia = sat?.colonia || pdf["Nombre de la Colonia"];
            const codigoPostal = sat?.codigoPostal || pdf["Código Postal"];

            debounceRegimen(informacion?.regimen);

            form.setFieldsValue({
              ...sat,
              razonSocial,
              nombre,
              estado: estado ? String(estado).toUpperCase() : estado,
              ciudad: ciudad ? String(ciudad).toUpperCase() : ciudad,
              calle,
              numeroExterior,
              numeroInterior,
              colonia,
              codigoPostal,
              rfc: pdf["RFC"],
              giro: informacion?.giros?.map((g: any) => g.id),
              idRegimenFiscal: informacion?.regimen?.id,
              claveSociedad: sat?.regimenCapital,
              tipoPersona: tipoPersonaDetectado,
            });

            if (sat?.regimenCapital) {
              setSociedadSat(sat.regimenCapital);
            }
            setTipoPersona(tipoPersonaDetectado);

            if (razonSocial !== "") {
              setRazonSocialPDF(razonSocial);
            }

            setAppendGiros(informacion.giros);
            if (informacion?.regimen !== null) {
              setAppendRegimen([informacion?.regimen]);
            }

            setInfoRequerida({
              rfc: pdf["RFC"],
              razonSocial,
            });
          },
          showNotificacion: true,
        });
      } catch (e) {
        return e;
      }
    },
    [debounceRegimen, form, http],
  );

  const getAvisoPrivacidadSimplificada = useCallback(async () => {
    try {
      await http.get({
        endpoint: "/proveedor/aviso-privacidad/simplificado.json",
        onSuccess: (res) => {
          setMensaje(`${res?.detalle}`);
        },
      });
    } catch (e) {
      return e;
    }
  }, [http]);

  const getAvisoPrivacidadIntegral = useCallback(async () => {
    try {
      await http.get({
        endpoint: "/proveedor/aviso-privacidad/integral.json",
        onSuccess: (res) => {
          setMensaje(`${res?.detalle}`);
        },
      });
    } catch (e) {
      return e;
    }
  }, [http]);

  const onFinish = async (values: any) => {
    setGuardando(true);
    const { telefono, celular, clave1, clave, codigoPostal } = values;
    const body = { ...values };

    try {
      body.celular = "" + quitarSignos(celular);
      body.telefono = "" + quitarSignos(telefono);
      body.codigoPostal = codigoPostal?.toString() || "";
      body.telefono = body.telefono?.replace("NaN", "");
      body.celular = body.celular?.replace("NaN", "");
      body.codigoPostal = body.codigoPostal?.replace("NaN", "");

      body.archivos = listaArchivos;

      if (idGrupo) {
        body.idGrupo = idGrupo;
      }

      if (
        !listaArchivos ||
        listaArchivos?.length === 0 ||
        !listaArchivos[0]?.ruta
      ) {
        notification.error({
          message: "Atención",
          description:
            "Nesesitas subir la CONSTANCIA DE SITUACIÓN FISCAL expedida por el SAT.",
          placement: "bottomRight",
        });
        setGuardando(false);
        return;
      }

      if (clave1 !== clave) {
        notification.error({
          message: "Atención",
          description: `Las contraseñas no coinciden.`,
          placement: "bottomRight",
        });
        setGuardando(false);
        return;
      }

      if (values.rfc !== infoRequerida?.rfc) {
        notification.error({
          message: "Atención",
          description: `Su RFC no coincide con el proporcionado en su constancia. (${infoRequerida?.rfc})`,
          placement: "bottomRight",
        });
        setGuardando(false);
        return;
      }

      if (values.razonSocial !== infoRequerida.razonSocial) {
        notification.error({
          message: "Atención",
          description: `Su Razón Social no coincide con el proporcionado en su constancia. (${infoRequerida.razonSocial})`,
          placement: "bottomRight",
        });
        setGuardando(false);
        return;
      }

      await http.post({
        endpoint: `proveedor/iniciar-sesion/registrar.json`,
        body,
        onSuccess: (res) => {
          setGuardado(res?.detalle);
        },
      });
    } catch (error) {
      setGuardando(false);
      return error;
    } finally {
      setGuardando(false);
    }
  };

  const altertaSociedadCapital = (seleccion: any) => {
    if (sociedadSat && sociedadSat !== seleccion) {
      return notification.warning({
        message: "Atención",
        description:
          "La Sociedad Capital que seleccionió es diferente a la proporcionada por su constancia.",
      });
    }
  };

  useEffect(() => {
    if (data && data?.resultado) {
      setModel(data?.resultado);
    }
  }, [data]);

  useEffect(() => {
    if (usuario && usuario?.id) {
      navigate({ to: "/perfil" });
    }
  }, [navigate, usuario]);

  useEffect(() => {
    if (isModalOpen && tipoModal === "SIMPLIFICADA") {
      getAvisoPrivacidadSimplificada();
    }
    if (isModalOpen && tipoModal === "INTEGRAL") {
      getAvisoPrivacidadIntegral();
    }
  }, [
    getAvisoPrivacidadSimplificada,
    getAvisoPrivacidadIntegral,
    isModalOpen,
    tipoModal,
  ]);

  useEffect(() => {
    if (model) {
      setGuardado(model);
    }
  }, [model]);

  useEffect(() => {
    if (
      listaArchivos?.length > 0 &&
      listaArchivos[0].ruta &&
      !tieneConstancia
    ) {
      setTieneConstancia(true);
      processPDF(`${VITE_ENV.BASE_API_URL}/recursos${listaArchivos[0].ruta}`);
    }
  }, [listaArchivos, processPDF, tieneConstancia]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header style={styles.header}>
        <Spin spinning={guardando} tip={"Cargando..."}>
          {!idGrupo ? (
            <Row gutter={[10, 10]} className="p-2 sm:p-6 bg-[#f5f5f5]">
              <Col span={24} style={{ backgroundColor: "#f5f5f5" }}>
                <Card style={{ width: "100%" }}>
                  <Row
                    gutter={[10, 10]}
                    align="middle"
                    className="mb-6 rounded-[5px] bg-[#242424] px-4 py-4 sm:px-8 lg:px-12"
                  >
                    <Col
                      xs={24}
                      sm={8}
                      className="flex justify-center sm:justify-start"
                    >
                      <Image
                        src={logo}
                        style={{ width: "100%", maxWidth: 200 }}
                        preview={false}
                        onClick={() => navigate({ to: "/" })}
                      />
                    </Col>
                    <Col xs={24} sm={16}>
                      <Typography.Title
                        level={3}
                        className="mb-0! text-center! text-lg! sm:text-left! sm:text-xl! md:text-2xl!"
                        style={{ color: "white" }}
                      >
                        <HomeOutlined onClick={() => navigate({ to: "/" })} /> /
                        Registro de Proveedores
                      </Typography.Title>
                    </Col>
                  </Row>

                  <Row style={{ padding: "0 8px 16px" }}>
                    <Col span={24}>
                      <Typography.Title level={4} style={{ margin: 0 }}>
                        Selecciona el grupo al que deseas registrarte
                      </Typography.Title>
                      <Typography.Text type="secondary">
                        Elige una de las siguientes opciones para continuar con
                        tu registro.
                      </Typography.Text>
                    </Col>
                  </Row>

                  <Spin spinning={cargandoGrupos}>
                    {gruposDisponibles?.length > 0 ? (
                      <Row gutter={[16, 16]} style={{ padding: "0 8px" }}>
                        {gruposDisponibles.map((g: any) => (
                          <Col key={g.id} xs={24} sm={12} md={8} lg={6}>
                            <Card
                              hoverable
                              onClick={() => handleSeleccionarGrupo(g.id)}
                              style={{ height: "100%" }}
                            >
                              <div className="flex flex-col items-center text-center gap-2">
                                {g?.logo ? (
                                  <Image
                                    src={g.logo}
                                    preview={false}
                                    style={{
                                      maxHeight: 80,
                                      objectFit: "contain",
                                    }}
                                  />
                                ) : (
                                  <TeamOutlined
                                    style={{ fontSize: 40, color: "#242424" }}
                                  />
                                )}
                                <Typography.Text strong>
                                  {g?.nombre}
                                </Typography.Text>
                                {g?.descripcion && (
                                  <Typography.Text
                                    type="secondary"
                                    className="text-sm"
                                  >
                                    {g.descripcion}
                                  </Typography.Text>
                                )}
                              </div>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    ) : (
                      !cargandoGrupos && (
                        <Empty
                          description="No hay grupos disponibles"
                          style={{ padding: "2em 0" }}
                        />
                      )
                    )}
                  </Spin>

                  <Row style={{ padding: "16px 8px 0" }} justify="end">
                    <Col>
                      <Button
                        size="large"
                        onClick={() => navigate({ to: "/" })}
                        icon={<ArrowLeftOutlined />}
                        type="dashed"
                      >
                        Volver
                      </Button>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          ) : guardado !== undefined ? (
            <Row gutter={[10, 10]} className="p-2 sm:p-6 bg-[#f5f5f5]">
              <Col span={24} style={{ backgroundColor: "#f5f5f5" }}>
                <Card style={{ width: "100%" }}>
                  <Row style={styles.cardHeader} justify={"space-between"}>
                    <Col span={10}>
                      <Image
                        src={logo}
                        preview={false}
                        onClick={() => navigate({ to: "/" })}
                        style={{ width: "60%", textAlign: "center" }}
                      />
                    </Col>
                    <Col span={14} style={{ alignSelf: "center" }}>
                      <Typography.Title level={3} style={{ color: "#ffffff" }}>
                        Registro realizado con éxito
                      </Typography.Title>
                    </Col>
                  </Row>
                  <Row gutter={[12, 12]} justify={"space-between"}>
                    <Col span={12} style={{ padding: "0 23px" }}>
                      <Row>
                        {guardado?.nombre && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                Nombre o Representante Legal:
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.nombre || ""}
                              </Typography>
                            </Col>
                          </>
                        )}
                        {guardado?.rfc && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                R.F.C.
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.rfc || ""}
                              </Typography>
                            </Col>{" "}
                          </>
                        )}
                        {guardado?.telefono && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                Teléfono
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.telefono?.replace("NaN", "") || ""}
                              </Typography>
                            </Col>
                          </>
                        )}
                        {guardado?.estado && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                Estado
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.estado || ""}
                              </Typography>
                            </Col>
                          </>
                        )}
                        {guardado?.colonia && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                Colonia
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.colonia || ""}
                              </Typography>
                            </Col>
                          </>
                        )}
                        {guardado?.numeroExterior && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                Número Exterior
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.numeroExterior || ""}
                              </Typography>
                            </Col>
                          </>
                        )}
                        {guardado?.codigoPostal && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                Código Postal
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.codigoPostal || ""}
                              </Typography>
                            </Col>
                          </>
                        )}
                      </Row>
                    </Col>
                    <Col span={12} style={{ padding: "0 23px" }}>
                      <Row>
                        {guardado?.correo && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                Correo Electrónico (usuario):
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.correo?.replace("NaN", "") || ""}
                              </Typography>
                            </Col>
                          </>
                        )}
                        {guardado?.razonSocial && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                Razón Social
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.razonSocial?.replace("NaN", "") ||
                                  ""}
                              </Typography>
                            </Col>{" "}
                          </>
                        )}
                        {guardado?.tipoPersona && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                Razón Social
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.tipoPersona || ""}
                              </Typography>
                            </Col>{" "}
                          </>
                        )}
                        {guardado?.celular && guardado?.celular !== "NaN" && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                Celular
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.celular?.replace("NaN", "") || ""}
                              </Typography>
                            </Col>
                          </>
                        )}
                        {guardado?.ciudad && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                Municipio
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.ciudad?.replace("NaN", "") || ""}
                              </Typography>
                            </Col>
                          </>
                        )}
                        {guardado?.calle && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                Calle
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.calle?.replace("NaN", "") || ""}
                              </Typography>
                            </Col>
                          </>
                        )}
                        {guardado?.numeroInterior && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                Número Interior
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.numeroInterior?.replace("NaN", "") ||
                                  ""}
                              </Typography>
                            </Col>
                          </>
                        )}
                        {guardado?.web && (
                          <>
                            <Col span={10} style={styles.colsText}>
                              <Typography style={styles.headerText}>
                                Sitio Web
                              </Typography>
                            </Col>
                            <Col span={14} style={styles.colsText}>
                              <Typography style={styles.textoGuardado}>
                                {guardado?.web?.replace("NaN", "") || ""}
                              </Typography>
                            </Col>
                          </>
                        )}
                      </Row>
                    </Col>
                    <Divider />
                    <Col>
                      <Button
                        size={"large"}
                        onClick={() => navigate({ to: "/" })}
                        icon={<ArrowLeftOutlined />}
                        type="primary"
                      >
                        Volver al inicio de sesión
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        size={"large"}
                        onClick={() => navigate({ to: "/" })}
                        type="primary"
                      >
                        Iniciar Sesión
                      </Button>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          ) : (
            <div className="p-2 sm:p-6 bg-[#f5f5f5]">
              <Card>
                <Row
                  gutter={[10, 10]}
                  align="middle"
                  className="mb-6 rounded-[5px] bg-[#242424] px-4 py-4 sm:px-8 lg:px-12"
                >
                  <Col
                    xs={24}
                    sm={8}
                    className="flex justify-center sm:justify-start"
                  >
                    <Image
                      src={logo}
                      style={{ width: "100%", maxWidth: 200 }}
                      preview={false}
                      onClick={() => navigate({ to: "/" })}
                    />
                  </Col>
                  <Col xs={24} sm={16}>
                    <Typography.Title
                      level={3}
                      className="mb-0! text-center! text-lg! sm:text-left! sm:text-xl! md:text-2xl!"
                      style={{ color: "white" }}
                    >
                      <HomeOutlined onClick={() => navigate({ to: "/" })} /> /
                      Registro de Proveedores{" "}
                      {grupo && `para el grupo de ${grupo?.nombre}`}
                    </Typography.Title>
                  </Col>
                </Row>
                <Form onFinish={onFinish} form={form} layout="vertical">
                  <Row gutter={[10, 16]}>
                    <Col span={24} md={12}>
                      <Row>
                        <Col span={24}>
                          <EtiquetaCampo
                            style={{ color: infoRequerida ? "#8bc34a" : "red" }}
                          >
                            Adjunta tu Constancia de Situación Fiscal para
                            Iniciar
                          </EtiquetaCampo>
                        </Col>
                        {
                          <Col span={24}>
                            <div className="flex flex-row items-center gap-3 p-2">
                              {listaArchivos?.map((doc) => (
                                <div
                                  key={doc.uuid || doc.nombre}
                                  className="shrink-0"
                                >
                                  <Tooltip title={doc.nombre}>
                                    <Card
                                      hoverable
                                      onClick={() => {
                                        window.open(
                                          `${VITE_ENV.BASE_API_URL}/recursos${doc.ruta}`,
                                        );
                                      }}
                                      actions={[
                                        <DeleteOutlined
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setListaArchivos([]);
                                            setTieneConstancia(false);
                                          }}
                                        />,
                                      ]}
                                      className="w-37.5 max-w-full"
                                    >
                                      <div className="flex flex-col w-full h-full text-sm align-middle items-center overflow-x-hidden">
                                        <FilePdfOutlined
                                          style={{
                                            fontSize: 40,
                                            color: "#FF4343",
                                          }}
                                        />
                                        <div className="w-full text-center text-sm font-semibold truncate">
                                          {doc?.nombre}
                                        </div>
                                        <div className="w-full text-center text-sm text-gray-400">
                                          {dayjs(doc?.creado).format(
                                            "DD/MM/YYYY HH:mm",
                                          )}
                                        </div>
                                      </div>
                                    </Card>
                                  </Tooltip>
                                </div>
                              ))}
                              {listaArchivos?.length === 1 ? null : (
                                <Upload
                                  showUploadList={false}
                                  name="archivo"
                                  accept=".pdf"
                                  maxCount={1}
                                  listType="picture-card"
                                  className="shrink-0 mb-0"
                                  onChange={(f) => {
                                    const file = f?.file;
                                    if (file.status === "done") {
                                      const lista: any = [];
                                      const archivo = {
                                        ...file?.response?.detalle,
                                        url: `${VITE_ENV.BASE_API_URL}/${file?.response?.detalle.ruta}`,
                                        name: file?.response?.detalle.nombre,
                                        uid: file?.response?.detalle.uuid,
                                        status: "done",
                                        thumbUrl: `${VITE_ENV.BASE_API_URL}/${file?.response?.detalle.ruta}`,
                                      };
                                      lista.push(archivo);
                                      setListaArchivos(lista);
                                    }
                                  }}
                                  action={`${VITE_ENV.BASE_API_URL}${Media.ENDPOINTS.SUBIR_CONSTANCIA}`}
                                >
                                  <p>
                                    <UploadOutlined />
                                    Subir Archivo
                                  </p>
                                </Upload>
                              )}
                              <Typography.Text
                                strong
                                className="text-xs sm:text-sm flex-1 leading-tight !text-red-600 font-bold"
                                style={{ color: "#dc2626" }}
                              >
                                * No debe tener una antigüedad mayor a 3 meses.
                              </Typography.Text>
                            </div>
                          </Col>
                        }
                      </Row>
                    </Col>
                    <Col span={24} md={12}>
                      <Form.Item
                        name="tipoPersona"
                        label={<EtiquetaCampo>Tipo Razón Social</EtiquetaCampo>}
                        rules={[
                          {
                            required: true,
                            message: "Por favor ingresar Razón Social",
                          },
                        ]}
                      >
                        <Select
                          size={"large"}
                          onSelect={(v) => setTipoPersona(v)}
                        >
                          <Select.Option value="Física">FÍSICA</Select.Option>
                          <Select.Option value="Moral">MORAL</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    {tipoPersona === "Moral" && (
                      <Col xs={24} md={12}>
                        <Form.Item
                          label={
                            <EtiquetaCampo>Sociedad Capital</EtiquetaCampo>
                          }
                          name="claveSociedad"
                        >
                          <SelectorQuery
                            queryProps={{
                              endpoint:
                                "proveedor/catalogos/sociedad-capital.json",
                              enabled: true,
                              extraParams: {
                                ordenar: "clave-asc",
                              },
                            }}
                            valueProp="clave"
                            onSelect={(v) => altertaSociedadCapital(v)}
                            selectProps={{
                              placeholder: "Seleccione...",
                            }}
                            labelRender={(data) =>
                              `${data?.data?.clave} - ${data?.data?.regimen}`
                            }
                            optionRender={(data) =>
                              `${data?.data?.clave} - ${data?.data?.regimen}`
                            }
                          />
                        </Form.Item>
                      </Col>
                    )}
                    <Col span={24} md={12}>
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          Modal.info({
                            title: "Constancia Fiscal Requerida",
                            content: (
                              <p
                                className={
                                  infoRequerida
                                    ? "font-semibold text-base py-2 text-green-600!"
                                    : "font-semibold text-base py-2 text-red-600!"
                                }
                                style={{
                                  color: infoRequerida ? "#8bc34a" : "#dc2626",
                                }}
                              >
                                Para obtener RFC en este formato de registro,
                                debe proporcionar primero su constancia fiscal
                                en formato PDF original del SAT.
                              </p>
                            ),
                            okText: "Entendido",
                            okButtonProps: {
                              style: { backgroundColor: "#000", color: "#fff" },
                            },
                          });
                        }}
                      >
                        <Form.Item
                          name={"rfc"}
                          label={<EtiquetaCampo>RFC</EtiquetaCampo>}
                          rules={[
                            {
                              required: true,
                            },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (ValidarRfc(value)) {
                                  return Promise.resolve();
                                } else {
                                  if (value)
                                    return Promise.reject(
                                      new Error(`Introduzca un R.F.C. válido`),
                                    );
                                  else return Promise.reject();
                                }
                              },
                            }),
                          ]}
                        >
                          <Input
                            size={"large"}
                            autoComplete={"off"}
                            disabled={disabled}
                            placeholder="Subir constancia fiscal"
                            style={
                              disabled ? { pointerEvents: "none" } : undefined
                            }
                            onInput={(e) =>
                              ((e.target as HTMLInputElement).value = (
                                e.target as HTMLInputElement
                              ).value.toUpperCase())
                            }
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        label={<EtiquetaCampo>Razón Social</EtiquetaCampo>}
                        name="razonSocial"
                        rules={[
                          {
                            required: true,
                            message: "Favor de ingresar su Razón Social.",
                            type: "string",
                          },
                          {
                            validator: (_, value) =>
                              razonSocialPDF !== "" && value !== razonSocialPDF
                                ? Promise.reject(
                                    new Error("La razón social no coincide"),
                                  )
                                : Promise.resolve(),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          size={"large"}
                          onInput={(e) =>
                            ((e.target as HTMLInputElement).value = (
                              e.target as HTMLInputElement
                            ).value.toUpperCase())
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        label={
                          <EtiquetaCampo>Correo electrónico</EtiquetaCampo>
                        }
                        name="correo"
                        rules={[
                          {
                            required: true,
                            message: "Favor de ingresar su Correo Electrónico.",
                            type: "email",
                          },
                        ]}
                        extra={
                          <span className="font-semibold text-gray-800">
                            Es importante proporcionar un correo válido para
                            recibir notificaciones
                          </span>
                        }
                      >
                        <Input type="email" size={"large"} />
                      </Form.Item>
                    </Col>
                    <Col span={24} md={12}>
                      <Form.Item
                        name={"telefono"}
                        label={<EtiquetaCampo>Teléfono</EtiquetaCampo>}
                        rules={[
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value) return Promise.resolve();
                              else if (
                                ValidarTelefono("" + quitarSignos(value))
                              ) {
                                return Promise.resolve();
                              } else {
                                return Promise.reject(
                                  new Error(
                                    `Intoduzca un Número de Teléfono valido`,
                                  ),
                                );
                              }
                            },
                          }),
                        ]}
                      >
                        <PatternFormat
                          customInput={Input}
                          mask="-"
                          patternChar="%"
                          autoComplete={"off"}
                          format="(%%%) %%% %%%%"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24} md={12}>
                      <Form.Item
                        name={"celular"}
                        label={<EtiquetaCampo>Celular</EtiquetaCampo>}
                        rules={[
                          {
                            required: true,
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value) return Promise.resolve();
                              else if (
                                ValidarTelefono("" + quitarSignos(value))
                              ) {
                                return Promise.resolve();
                              } else {
                                return Promise.reject(
                                  new Error(
                                    `Intoduzca un Número de Teléfono valido`,
                                  ),
                                );
                              }
                            },
                          }),
                        ]}
                      >
                        <PatternFormat
                          customInput={Input}
                          mask="-"
                          patternChar="%"
                          autoComplete={"off"}
                          format="(%%%) %%% %%%%"
                        />
                      </Form.Item>
                    </Col>
                    {tipoPersona === "Moral" && (
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          label={
                            <EtiquetaCampo>
                              Nombre Representante Legal
                            </EtiquetaCampo>
                          }
                          name="nombre"
                          rules={[
                            {
                              required: true,
                              message: "Favor de ingresar su Nombre.",
                              type: "string",
                            },
                          ]}
                        >
                          <Input
                            type="text"
                            size={"large"}
                            onInput={(e) =>
                              ((e.target as HTMLInputElement).value = (
                                e.target as HTMLInputElement
                              ).value.toUpperCase())
                            }
                          />
                        </Form.Item>
                      </Col>
                    )}
                    <Divider />
                    <Col span={24} md={12}>
                      <Form.Item
                        label={<EtiquetaCampo>Estado</EtiquetaCampo>}
                        name="estado"
                        rules={[
                          {
                            required: true,
                            message: "Por favor seleccionar un Estado.",
                          },
                        ]}
                      >
                        <SelectorQuery
                          queryProps={{
                            endpoint: "proveedor/catalogos/estado.json",
                            enabled: true,
                            extraParams: {
                              ordenar: "clave-asc",
                              limite: 32,
                            },
                          }}
                          selectProps={{
                            placeholder: "Seleccione...",
                            allowClear: true,
                          }}
                          onSelect={(r) => setEstado(r)}
                          valueProp="nombre"
                          labelRender={(data) => `${data?.data?.nombre}`}
                          optionRender={(data) => `${data?.data?.nombre}`}
                          append={appendRegimen}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24} md={12}>
                      <Form.Item
                        label={<EtiquetaCampo>Municipio</EtiquetaCampo>}
                        name="ciudad"
                        rules={[
                          {
                            required: true,
                            message: "Por favor seleccionar un Municipio.",
                          },
                        ]}
                      >
                        <SelectorQuery
                          queryProps={{
                            endpoint: "proveedor/catalogos/municipio.json",
                            enabled: estado !== null,
                            extraParams: {
                              ordenar: "clave-asc",
                              estado: estado?.id,
                              limite: 570,
                            },
                          }}
                          valueProp="nombre"
                          selectProps={{
                            placeholder: "Seleccione...",
                            allowClear: true,
                          }}
                          labelRender={(data) => `${data?.data?.nombre}`}
                          optionRender={(data) => `${data?.data?.nombre}`}
                          append={appendRegimen}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24} md={12}>
                      <Form.Item
                        name="calle"
                        label={<EtiquetaCampo>Calle</EtiquetaCampo>}
                        rules={[
                          {
                            required: true,
                            message: "Por favor ingresar una Calle.",
                          },
                        ]}
                      >
                        <Input
                          size={"large"}
                          autoComplete={"off"}
                          onInput={(e) =>
                            ((e.target as HTMLInputElement).value = (
                              e.target as HTMLInputElement
                            ).value.toUpperCase())
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={{ span: 12 }}
                      sm={{ span: 12 }}
                      md={{ span: 6 }}
                      lg={{ span: 6 }}
                    >
                      <Form.Item
                        name="numeroExterior"
                        label={<EtiquetaCampo>Número Exterior</EtiquetaCampo>}
                        rules={[
                          {
                            required: true,
                            message: "Por favor ingresar un Número Exterior.",
                          },
                        ]}
                      >
                        <Input size={"large"} autoComplete={"off"} />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={{ span: 12 }}
                      sm={{ span: 12 }}
                      md={{ span: 6 }}
                      lg={{ span: 6 }}
                    >
                      <Form.Item
                        name="numeroInterior"
                        label={<EtiquetaCampo>Número Interior</EtiquetaCampo>}
                      >
                        <Input size={"large"} autoComplete={"off"} />
                      </Form.Item>
                    </Col>
                    <Col span={24} md={12}>
                      <Form.Item
                        name="colonia"
                        label={<EtiquetaCampo>Colonia</EtiquetaCampo>}
                        rules={[
                          {
                            required: true,
                            message: "Por favor ingresar una Colonia.",
                          },
                        ]}
                      >
                        <Input
                          size={"large"}
                          autoComplete={"off"}
                          onInput={(e) =>
                            ((e.target as HTMLInputElement).value = (
                              e.target as HTMLInputElement
                            ).value.toUpperCase())
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24} md={12}>
                      <Form.Item
                        name="codigoPostal"
                        label={<EtiquetaCampo>Código Postal</EtiquetaCampo>}
                        rules={[
                          {
                            required: true,
                            message: "Por favor ingresar un Código Postal.",
                          },
                        ]}
                      >
                        <InputNumber
                          size={"large"}
                          autoComplete={"off"}
                          maxLength={5}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24} md={12}>
                      <Form.Item
                        name="idRegimenFiscal"
                        label={<EtiquetaCampo>Régimen Fiscal</EtiquetaCampo>}
                        rules={[
                          {
                            required: true,
                            message: "Por favor seleccionar un Régimen Fiscal.",
                          },
                        ]}
                      >
                        <SelectorQuery
                          queryProps={{
                            endpoint: "proveedor/catalogos/regimen-fiscal.json",
                            enabled: true,
                            extraParams: {
                              ordenar: "clave-asc",
                            },
                          }}
                          onSelect={debounceRegimen}
                          selectProps={{
                            placeholder: "Seleccione...",
                            allowClear: true,
                          }}
                          labelRender={(data) =>
                            `${data?.data?.clave} - ${data?.data?.nombre?.toUpperCase()}`
                          }
                          optionRender={(data) =>
                            `${data?.data?.clave} - ${data?.data?.nombre?.toUpperCase()}`
                          }
                          append={appendRegimen}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="web"
                        label={<EtiquetaCampo>Sitio Web</EtiquetaCampo>}
                      >
                        <Input size={"large"} autoComplete={"off"} />
                      </Form.Item>
                    </Col>
                    <Divider />
                    <Col span={24} md={12}>
                      <Form.Item
                        name={"clave"}
                        label={<EtiquetaCampo>Contraseña</EtiquetaCampo>}
                        rules={[
                          {
                            required: true,
                            message: "Por favor ingrese una contraseña.",
                          },
                          {
                            pattern: /^.{8,}$/,
                            message: "Debe contener mínimo 8 caracteres",
                          },
                          {
                            pattern: /^.{0,20}$/,
                            message: "Debe contener máximo 20 caracteres",
                          },
                          {
                            pattern: /[A-Z]/,
                            message:
                              "Debe contener al menos una letra mayúscula",
                          },
                          {
                            pattern: /[a-z]/,
                            message:
                              "Debe contener al menos una letra minúscula",
                          },
                          {
                            pattern: /\d/,
                            message: "Debe contener al menos un dígito",
                          },
                          {
                            pattern: /[$@!%*?#&_-]/,
                            message:
                              "Debe contener al menos 1 carácter especial ( $ @ ! % * ? # & _ - )",
                          },
                          {
                            pattern: /^\S+$/,
                            message: "No debe contener espacios en blanco",
                          },
                        ]}
                      >
                        <Input.Password
                          size={"large"}
                          autoComplete="one-time-code"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24} md={12}>
                      <Form.Item
                        name={"clave1"}
                        label={
                          <EtiquetaCampo>Confirmar Contraseña</EtiquetaCampo>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Por favor confirme su contraseña.",
                          },
                          {
                            pattern: /^.{8,}$/,
                            message: "Debe contener mínimo 8 caracteres",
                          },
                          {
                            pattern: /^.{0,20}$/,
                            message: "Debe contener máximo 20 caracteres",
                          },
                          {
                            pattern: /[A-Z]/,
                            message:
                              "Debe contener al menos una letra mayúscula",
                          },
                          {
                            pattern: /[a-z]/,
                            message:
                              "Debe contener al menos una letra minúscula",
                          },
                          {
                            pattern: /\d/,
                            message: "Debe contener al menos un dígito",
                          },
                          {
                            pattern: /[$@!%*?#&_-]/,
                            message:
                              "Debe contener al menos 1 carácter especial ( $ @ ! % * ? # & _ - )",
                          },
                          {
                            pattern: /^\S+$/,
                            message: "No debe contener espacios en blanco",
                          },
                        ]}
                      >
                        <Input.Password
                          size={"large"}
                          autoComplete="one-time-code"
                        />
                      </Form.Item>
                    </Col>
                    <Divider
                      style={{ margin: 0, backgroundColor: "#b2b2b2" }}
                    />
                    <Col span={24}>
                      <div className="flex! items-start gap-2 bg-neutral-900 text-white p-6 rounded-lg">
                        <Checkbox
                          onChange={() => setDisabled((prev) => !prev)}
                          style={{ color: "black" }}
                        />
                        <strong className="text-sm sm:text-base text-white">
                          Declara bajo protesta de decir verdad que la
                          información y documentación proporcionada es verídica,
                          por la que en caso de existir falsedad en ella, tengo
                          pleno conocimiento que se aplicarán sanciones
                          administrativas.{" "}
                          <Button
                            type="link"
                            className="px-0! h-auto! text-sky-400! hover:text-sky-300! underline font-semibold mx-1"
                            onClick={() => {
                              setIsModalOpen(true);
                              setTipoModal("SIMPLIFICADA");
                            }}
                          >
                            Ver aviso de privacidad Simplificada.
                          </Button>{" "}
                          <Typography.Text className="text-white">
                            En caso de dudas, contáctanos por el correo de
                            soporte.
                          </Typography.Text>{" "}
                        </strong>
                      </div>
                    </Col>
                    <Col
                      span={24}
                      className="flex! flex-wrap justify-end gap-2 pt-2"
                    >
                      <Button
                        size={"large"}
                        onClick={() => navigate({ to: "/" })}
                        icon={<ArrowLeftOutlined />}
                        type="dashed"
                      >
                        Volver
                      </Button>
                      <Button
                        size={"large"}
                        disabled={disabled || bloqueaRegimen}
                        type="primary"
                        htmlType="submit"
                      >
                        Registrarse
                      </Button>
                    </Col>
                  </Row>
                  <Modal
                    title={
                      tipoModal !== "SIMPLIFICADA"
                        ? "AVISO DE PRIVACIDAD INTEGRAL"
                        : "AVISO DE PRIVACIDAD SIMPLIFICADO"
                    }
                    open={isModalOpen}
                    footer={[
                      <Button
                        type="primary"
                        onClick={() => {
                          setIsModalOpen(false);
                          setTipoModal("");
                        }}
                      >
                        OK
                      </Button>,
                    ]}
                    /* onClose={() => {
                      setIsModalOpen(false);
                      setTipoModal("");
                    }} */
                    onCancel={() => {
                      setIsModalOpen(false);
                      setTipoModal("");
                    }}
                    style={{ minWidth: "80vw" }}
                    styles={{ body: { overflow: "auto", maxHeight: 400 } }}
                  >
                    <Typography.Text>{parse(mensaje)}</Typography.Text>
                  </Modal>
                </Form>
              </Card>
            </div>
          )}
        </Spin>
      </Header>
    </Layout>
  );
}
